import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { SizePane } from 'page/ProfileScreen/SizeSlider/SizePane'
import { isMax } from 'page/ProfileScreen/SizeSlider/SizeSlider'
import { store } from 'store/store'

export const HipsSlider = observer(() => {
  const form = store.profile.form
  const { min, max } = store.profile.form.cfg.dimensions.hips
  const value = form.hips
  const plus = isMax(value, max)

  const onChange = useLatestCallback((value: number) => {
    form.setHips(value)
  })

  return <SizePane label={i18n('HipGirth')} value={value} plus={plus}
    min={min} max={max} onChange={onChange} />
})
